import styled from 'styled-components';

export const SwitchFormLayout = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 40px;
`;
